import Panel from "components/shared/Panel/Panel";
import styled, { css, type RuleSet } from "styled-components";

export const StyledPanel = styled(Panel)<{ isMiniTile?: boolean }>`
  ${({ isMiniTile }): false | RuleSet =>
    !!isMiniTile &&
    css`
      padding: 1rem;
    `}
`;
